import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Inbox from '../../components/Inbox/Inbox';
import LoadingErrorMessage from '../../components/LoadingErrorMessage/LoadingErrorMessage';
import MessageCenterFooter from '../../components/MessageCenterFooter/MessageCenterFooter';
import MobileNewMessageButton from '../../components/MobileNewMessageButton/MobileNewMessageButton';
import Sent from '../../components/Sent/Sent';
import WorkPlaceRetirementLink from '../../components/WorkPlaceRetirement/WorkPlaceRetirementLink';
import FillWidthButton from '../../shared/FillWidthButton/FillWidthButton';
import { TabContent, TabItem, TabItems, Tabs } from '../../shared/Tabs/Tabs';
import { callApi, MESSAGES } from '../../utils/api';
import styles from './Messages.module.scss';

const tabs = [
  {
    component: Inbox,
    name: 'Inbox'
  },
  {
    component: Sent,
    name: 'Sent'
  }
];

const Messages = ({
  additionalState: { defaultSelected } = {},
  apiKey,
  baseUrl,
  hasTracOnly,
  inboxMessageCache: inboxMessages,
  openModal,
  requestStatus,
  sentMessageCache: sentMessages,
  setMessageFromId,
  setRequestStatus,
  showInboxHeading,
  theme,
  transition,
  updateInboxMessageCache,
  updateSentMessageCache
}) => {
  useEffect(() => {
    (async () => {
      /* currently removing auth because AAM is the only consumer and this component will be accessible in a logged in state
      behind the nitro auth gate
       */
      /* await loginWithService(apiKey); */
      try {
        const response = await callApi(baseUrl, apiKey, MESSAGES);
        const { inbox = [], sent = [], taxId } = await response.json();
        setMessageFromId(taxId);
        setRequestStatus(response.status);
        updateInboxMessageCache(inbox);
        updateSentMessageCache(sent);
      } catch (e) {
        console.log('FATAL MSG ERROR: ', e);
      }
    })();
  }, []);
  const inboxCount = `(${inboxMessages.filter(m => !m.viewed).length})`;
  const renderActionButtonHelper = () => {
    if (hasTracOnly) {
      return <WorkPlaceRetirementLink displayMode={'tab'} />;
    }

    return (
      <FillWidthButton
        className={styles["branded-button"]}
        onClick={() => transition('compose')}
      >
        New Message
      </FillWidthButton>
    );
  };
  return (
    <React.Fragment>
      <div className={styles['message-center-container']}>
        {showInboxHeading && (
          <h2 className={`${styles.header} branded-header`}>Message Center</h2>
        )}
        <div className={styles.nav}>
          <Tabs defaultSelected={defaultSelected || tabs[0].name}>
            <TabItems renderActionButton={() => renderActionButtonHelper()}>
              {tabs.map(tab => (
                <TabItem
                  id={tab.name}
                  key={tab.name}
                  name={`${tab.name}${
                    tab.name === 'Inbox' ? ' ' + inboxCount : ''
                  }`}
                />
              ))}
            </TabItems>
            {tabs.map(tab => (
              <TabContent key={tab.name} name={tab.name}>
                {requestStatus > 0 && requestStatus !== 200 ? (
                  <LoadingErrorMessage />
                ) : (
                  <tab.component
                    baseUrl={baseUrl}
                    hasTracOnly={hasTracOnly}
                    messages={
                      tab.name === 'Inbox' ? inboxMessages : sentMessages
                    }
                    openModal={openModal}
                    requestStatus={requestStatus}
                    theme={theme}
                    transition={transition}
                  />
                )}
              </TabContent>
            ))}
          </Tabs>
        </div>
        <MessageCenterFooter />
      </div>
      <MobileNewMessageButton transition={transition} />
    </React.Fragment>
  );
};

Messages.propTypes = {
  additionalState: PropTypes.object,
  apiKey: PropTypes.string,
  baseUrl: PropTypes.string,
  hasTracOnly: PropTypes.bool,
  inboxMessageCache: PropTypes.array,
  openModal: PropTypes.func,
  requestStatus: PropTypes.number,
  sentMessageCache: PropTypes.array,
  setMessageFromId: PropTypes.func,
  setRequestStatus: PropTypes.func,
  showInboxHeading: PropTypes.bool,
  theme: PropTypes.oneOf(['ak529', 'md529', 'na529', 'default']),
  transition: PropTypes.func,
  updateInboxMessageCache: PropTypes.func,
  updateSentMessageCache: PropTypes.func,
  webViewEnabled: PropTypes.bool
};

export default Messages;
